import { LocText } from '../Components/LocText';

export function NoPage() {
    return <LocText text="PageNotFound" />;
}
